export default "__VITE_ASSET__71b893dc__"